import React, { useContext, useLayoutEffect, useState } from "react";
import "./index.scss";
import NavBar from "../../components/Navbarr";
import SideBarAdmin from "../../components/SideBarAdmin";
import Footerr from "../../components/Footerr";
import AccessDenied from "../../components/AccessDenied";
import { UserContext } from "../../components/context/userContext";

import ListOrders from "../../components/ListOrders";


function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}



function Orders() {
  const { user } = useContext(UserContext);
  const { width } = useWindowDimensions();

  return (
    <>
      {user?.role == 1 ? (
        <div>
          <div>
            <NavBar />
          </div>
          <div className="dashboard-container">
            <div className="side-bar-container">
              <SideBarAdmin widthWindow={width} screen={"orders"} />
            </div>
            <div className="body-container">
              <div className="header-body">
                <div className="wrapper">
                  <h3>Orders</h3>
                </div>
              </div>
              <ListOrders />
            </div>
          </div>
          <div>
            <Footerr />
          </div>
        </div>
      ) : (
        <div>
          <div>
            <NavBar />
          </div>
          <div className="dashboard-container">
            <AccessDenied />
          </div>
          <div>
            <Footerr />
          </div>
        </div>
      )}
    </>
  );
}

export default Orders;
